import { marked } from 'marked';

const parseAllDocumenation = (docs) => {
  const iterate = (set) => {
    return set.map((n) => {
      if (n.pageContent) {
        try {
          n.data = marked.parse(n.pageContent);
        } catch (e) {}
      }
      if (n.children && n.children.length > 0) {
        n.children = iterate(n.children);
      }
      return n;
    });
  };
  docs = iterate(docs);

  const docMap = {};
  docs.forEach((n) => {
    docMap[n.id] = n;
  });
  docs.forEach((n) => {
    docMap[n.id].children = docMap[n.id].children || [];
    docMap[n.id].children = docMap[n.id].children.map((c) => {
      docMap[c.id].isChild = true;
      return docMap[c.id];
    });
  });

  for (const key in docMap) {
    if (docMap[key].isChild) {
      delete docMap[key];
    }
  }

  docs = Object.values(docMap);

  const recurse = (set, parentPath = [], parents = []) => {
    for (let i = 0; i < set.length; ++i) {
      let path = [...parentPath, set[i].slug];
      set[i].path = path;
      set[i].route = `/help/${path.join('/')}`;
      set[i].breadcrumb = [...parents];
      if (set[i].children.length > 0) {
        recurse(set[i].children, [...path], [...parents, { slug: set[i].slug, name: set[i].name, route: set[i].route }]);
      }
    }
  };

  recurse(docs);
  return docs;
};

export default parseAllDocumenation;
